// Utility function to update theme-color meta tag for iOS Safari
export const updateThemeColor = (color: string) => {
  let metaThemeColor = document.querySelector('meta[name="theme-color"]');
  
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta');
    metaThemeColor.setAttribute('name', 'theme-color');
    document.getElementsByTagName('head')[0].appendChild(metaThemeColor);
  }
  
  metaThemeColor.setAttribute('content', color);
};
